/**
 * Gold Code Input Component
 *
 * Wraps around the ReactCodeInput component. It takes in a answer prop which is the 
 * expected input value, and renders a gold-colored input field with the number 
 * of fields equal to the length of the answer prop. It also has functions to 
 * check if the input value is correct and to update the parent component with the 
 * input value. The component has default props for answer, value, onCorrect, 
 * onIncorrect, and onUpdate, and prop types are defined for all props.
 */

import React from 'react'
import PropTypes from 'prop-types'
import ReactCodeInput from 'react-code-input'
import { normalizeAnswer } from '../utils/helpers'

export default class GoldInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      numFields: 0,
    }
    this.inputRef = React.createRef()
    this.setNumFields = this.setNumFields.bind(this)
    this.checkCorrect = this.checkCorrect.bind(this)
  }

  componentDidMount() {
    this.setNumFields()
  }

  setNumFields() {
    const { answer } = this.props
    this.setState({
      numFields: answer.length,
    })
  }

  checkCorrect(value) {
    //console.log(value)
    this.props.onUpdate(value)
    if (value.replace(` `, ``).length == this.state.numFields) {
      // actually check if it's correct
      if (normalizeAnswer(this.props.answer) == normalizeAnswer(value)) {
        this.props.onCorrect()
      } else {
        this.props.onIncorrect()
      }
    }
  }

  render() {
    const { numFields } = this.state

    return (
      <div className="gold-input-container py-3 px-3">
        <ReactCodeInput
          ref={this.inputRef}
          autoFocus={false}
          type="text"
          fields={numFields}
          onChange={this.checkCorrect}
          forceUppercase={true}
          value={this.props.value}
          initialValue={this.props.initialValue}
          novalidate
        />
      </div>
    )
  }
}

GoldInput.defaultProps = {
  answer: ``,
  value: ``,
  onCorrect: () => {},
  onIncorrect: () => {},
  onUpdate: () => {},
}

GoldInput.propTypes = {
  answer: PropTypes.string,
  value: PropTypes.string,
  onCorrect: PropTypes.func,
  onIncorrect: PropTypes.func,
  onUpdate: PropTypes.func,
  initialValue: PropTypes.string,
}
